/* ============================================================
   BELLA NOTTE · v17 — הוספה לעגלה מתוך רשימת הפריטים שנשמרו.

   למה זה לא פשוט "מוסיף לעגלה":
   לכל שמלה יש צבע ומידה. הוספה ישירה הייתה בוחרת מידה במקומה,
   וזה לא באג טכני — זו הזמנה שגויה והחזרה. לכן הפלוס
   פותח בורר קומפקטי ורק אחרי בחירת מידה מתבצעת ההוספה.
   מוצר עם וריאנט אחד בלבד נוסף ישירות.

   רענון העגלה — נקודה רגישה, נבדקה בפועל:
   fetchCartData() של cart-items-component מביא נתונים אבל לא מצייר
   מחדש את המגירה. לכן מבקשים משופיפיי את ה-HTML המעודכן של
   הסקשן (sections: 'cart-drawer-section' בקריאה ל-/cart/add.js)
   ומחליפים רק שני צומתים: cart-items-component ו-.cart-drawer__summary.
   המגירה עצמה (ה-dialog) לא נוגעת — ולכן היא לא נסגרת ולא קופצת.
   מנגנון המתנה, האפסייל ושורת האמון מרונדרים מחדש על ידי השרת
   בתוך אותו HTML, ולכן הם מתעדכנים לבד.

   המונה של העגלה מתעדכן דרך renderCartBubble של רכיב cart-icon
   של התבנית — כך מקבלים גם את האנימציה ואת שמירת ה-sessionStorage
   שלה, בלי לשכפל לוגיקה.
   ============================================================ */

(function () {
  if (window.__bnWishCart) return;
  window.__bnWishCart = true;

  var cache = {};
  var picked = {};

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function optIndex(product, words) {
    var opts = product.options || [];
    for (var i = 0; i < opts.length; i++) {
      var name = (typeof opts[i] === 'string' ? opts[i] : opts[i].name) || '';
      name = name.toLowerCase();
      for (var w = 0; w < words.length; w++) {
        if (name.indexOf(words[w]) > -1) return i;
      }
    }
    return -1;
  }

  function optVal(variant, i) {
    return variant['option' + (i + 1)];
  }

  function uniq(list) {
    var out = [];
    for (var i = 0; i < list.length; i++) {
      if (list[i] && out.indexOf(list[i]) === -1) out.push(list[i]);
    }
    return out;
  }

  function msg(box, text, kind) {
    var el = box.querySelector('.bn-wishp__msg');
    if (!el) return;
    el.textContent = text || '';
    el.className = 'bn-wishp__msg' + (kind ? ' bn-wishp__msg--' + kind : '');
  }

  /* ---------- ציור הבורר ---------- */

  function renderPicker(box, product) {
    var ci = optIndex(product, ['צבע', 'color', 'colour']);
    var si = optIndex(product, ['מידה', 'size']);
    var id = box.getAttribute('data-bn-pick-for');

    var colors = ci > -1 ? uniq(product.variants.map(function (v) { return optVal(v, ci); })) : [];
    if (!picked[id] && colors.length) {
      for (var i = 0; i < product.variants.length; i++) {
        if (product.variants[i].available) { picked[id] = optVal(product.variants[i], ci); break; }
      }
      if (!picked[id]) picked[id] = colors[0];
    }

    var html = '';

    if (colors.length > 1) {
      html += '<p class="bn-wishp__lbl">צבע</p><div class="bn-wishp__opts">';
      for (var c = 0; c < colors.length; c++) {
        var hasAny = product.variants.some(function (v) {
          return optVal(v, ci) === colors[c] && v.available;
        });
        html +=
          '<button type="button" class="bn-wishp__opt" data-bn-pick-color="' + esc(colors[c]) + '"' +
          ' aria-pressed="' + (picked[id] === colors[c] ? 'true' : 'false') + '"' +
          (hasAny ? '' : ' disabled') + '>' + esc(colors[c]) + '</button>';
      }
      html += '</div>';
    }

    if (si > -1) {
      var sizes = uniq(product.variants.map(function (v) { return optVal(v, si); }));
      html += '<p class="bn-wishp__lbl">מידה</p><div class="bn-wishp__opts">';
      for (var s = 0; s < sizes.length; s++) {
        var match = null;
        for (var k = 0; k < product.variants.length; k++) {
          var v = product.variants[k];
          if (optVal(v, si) !== sizes[s]) continue;
          if (ci > -1 && colors.length > 1 && optVal(v, ci) !== picked[id]) continue;
          match = v;
          if (v.available) break;
        }
        var ok = match && match.available;
        html +=
          '<button type="button" class="bn-wishp__opt" data-bn-pick-size="' + (match ? match.id : '') + '"' +
          (ok ? '' : ' disabled') + '>' + esc(sizes[s]) + '</button>';
      }
      html += '</div>';
    }

    html += '<p class="bn-wishp__msg">בחרי מידה והפריט ייכנס לעגלה.</p>';
    box.innerHTML = html;
  }

  /* ---------- רענון העגלה ---------- */

  function applySection(sectionHtml) {
    if (!sectionHtml) return;
    try {
      var doc = new DOMParser().parseFromString(sectionHtml, 'text/html');
      var pairs = [
        ['cart-items-component', '#cart-drawer cart-items-component'],
        ['.cart-drawer__summary', '#cart-drawer .cart-drawer__summary']
      ];
      for (var i = 0; i < pairs.length; i++) {
        var fresh = doc.querySelector(pairs[i][0]);
        var cur = document.querySelector(pairs[i][1]);
        if (fresh && cur) cur.replaceWith(fresh);
      }
    } catch (e) {}
  }

  function refreshBubble() {
    fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var icon = document.querySelector('cart-icon');
        if (icon && typeof icon.renderCartBubble === 'function') icon.renderCartBubble(cart.item_count);
      })
      .catch(function () {});
  }

  /* ---------- הוספה ---------- */

  function addVariant(variantId, box, btn) {
    if (!variantId) return;
    if (btn) btn.disabled = true;
    msg(box, 'מוסיפות...', null);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({
        items: [{ id: Number(variantId), quantity: 1 }],
        sections: 'cart-drawer-section'
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        if (j.status) {
          msg(box, j.description || 'לא הצלחנו להוסיף. נסי שוב.', 'err');
          return;
        }
        applySection(j.sections && j.sections['cart-drawer-section']);
        refreshBubble();
        msg(box, 'נוסף לעגלה ✓', 'ok');

        var item = box.closest('.bn-wishp__item');
        var plus = item && item.querySelector('.bn-wishp__add');
        if (plus) {
          plus.classList.remove('bn-wishp__add--open');
          plus.classList.add('bn-wishp__add--done');
          plus.textContent = '✓';
          setTimeout(function () {
            plus.classList.remove('bn-wishp__add--done');
            plus.textContent = '+';
          }, 1800);
        }
        setTimeout(function () { box.setAttribute('hidden', ''); }, 1200);
      })
      .catch(function () {
        msg(box, 'לא הצלחנו להוסיף. נסי שוב.', 'err');
      })
      .finally(function () {
        if (btn) btn.disabled = false;
      });
  }

  /* ---------- אירועים ---------- */

  document.addEventListener(
    'click',
    function (e) {
      var t = e.target;
      if (!t || !t.closest) return;

      /* בחירת צבע */
      var colorBtn = t.closest('[data-bn-pick-color]');
      if (colorBtn) {
        e.preventDefault();
        e.stopPropagation();
        var cbox = colorBtn.closest('.bn-wishp__pick');
        var cid = cbox.getAttribute('data-bn-pick-for');
        picked[cid] = colorBtn.getAttribute('data-bn-pick-color');
        if (cache[cid]) renderPicker(cbox, cache[cid]);
        return;
      }

      /* בחירת מידה — וזו גם ההוספה */
      var sizeBtn = t.closest('[data-bn-pick-size]');
      if (sizeBtn) {
        e.preventDefault();
        e.stopPropagation();
        var sbox = sizeBtn.closest('.bn-wishp__pick');
        addVariant(sizeBtn.getAttribute('data-bn-pick-size'), sbox, sizeBtn);
        return;
      }

      /* הפלוס */
      var plus = t.closest('[data-bn-wish-add]');
      if (!plus) return;
      e.preventDefault();
      e.stopPropagation();

      var item = plus.closest('.bn-wishp__item');
      var box = item.querySelector('.bn-wishp__pick');
      var id = plus.getAttribute('data-bn-wish-add');
      var url = plus.getAttribute('data-bn-wish-url') || '';

      if (!box.hasAttribute('hidden')) {
        box.setAttribute('hidden', '');
        plus.classList.remove('bn-wishp__add--open');
        return;
      }

      box.setAttribute('data-bn-pick-for', id);
      box.removeAttribute('hidden');
      plus.classList.add('bn-wishp__add--open');

      if (cache[id]) {
        renderPicker(box, cache[id]);
        return;
      }

      box.innerHTML = '<p class="bn-wishp__msg">טוענת מידות...</p>';

      var jsonUrl = url.split('?')[0].split('#')[0] + '.js';
      fetch(jsonUrl, { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (product) {
          if (!product || !product.variants || !product.variants.length) throw new Error('no variants');
          cache[id] = product;

          /* וריאנט אחד בלבד — אין מה לבחור, מוסיפים ישירות */
          if (product.variants.length === 1) {
            box.innerHTML = '<p class="bn-wishp__msg"></p>';
            addVariant(product.variants[0].id, box, plus);
            return;
          }

          renderPicker(box, product);
        })
        .catch(function () {
          box.innerHTML =
            '<p class="bn-wishp__msg bn-wishp__msg--err">לא הצלחנו לטעון את המידות. ' +
            '<a href="' + esc(url) + '">לעמוד המוצר</a></p>';
        });
    },
    true
  );
})();
